import '../App.css';
import { useNavigate } from 'react-router-dom';
import UserRegister from '../model/request/UserRegister';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import TopBar from './TopBar';
import logo from '../images/logo.jpeg';
import Offeradd from './Offeradd.js';

function Personal() {
    const navigation = useNavigate()
    var location = useLocation();
    var { userObject } = location.state || {};



    // var userRegister = new UserRegister();


    var [Maritalstatus, setMaritalstatus] = useState("");
    var [MaritalstatusError, setMaritalstatusError] = useState("");

    var [Height, setHeight] = useState("");
    var [HeightError, setHeightError] = useState();

    var [Familystatus, setFamilystatus] = useState("");
    var [FamilystatusError, setFamilystatusError] = useState();

    var [Familytype, setFamilytype] = useState("");
    var [FamilytypeError, setFamilytypeError] = useState();

    var [familyvalues, setfamilyvalues] = useState("");
    var [familyvaluesError, setfamilyvaluesError] = useState();

    var [Anydisability, setAnydisability] = useState("");
    var [AnydisabilityError, setAnydisabilityError] = useState();

    useEffect(() => {
        if (!userObject) {
            navigation('/');
        }
    }, [userObject, navigation]);


    if (!userObject) {
        return null;
    }
    var userRegister = Object.setPrototypeOf(userObject, UserRegister.prototype);
    function clicktoQualificationscreen() {


        if (validation()) {
            userRegister.marital_Status = parseInt(Maritalstatus);
            userRegister.height = parseInt(Height);
            userRegister.family_Status = parseInt(Familystatus);
            userRegister.family_Type = parseInt(Familytype);
            userRegister.family_Values = parseInt(familyvalues);
            userRegister.any_Disability = parseInt(Anydisability);
            navigation('/Qualification', { state: { userRegister } })
        }
    }
    function validation() {

        var isFlage = true


        if (Maritalstatus == "") {
            setMaritalstatusError("Please Enter Your Marital Status.")
            isFlage = false
        }
        else {
            setMaritalstatusError("")
        }
        if (Height == "") {
            setHeightError("Please Enter Your Height.")
            isFlage = false
        }
        else {
            setHeightError("")
        }
        if (Familystatus == "") {
            setFamilystatusError("Please Enter Your Family Status.")
            isFlage = false
        }
        else {
            setFamilystatusError("")
        }
        if (Familytype == "") {
            setFamilytypeError("Please Enter Your Family Type.")
            isFlage = false
        }
        else {
            setFamilytypeError("")
        }
        if (familyvalues == "") {
            setfamilyvaluesError("Please Enter Your Family Values.")
            isFlage = false
        }
        else {
            setfamilyvaluesError("")
        }
        if (Anydisability == "") {
            setAnydisabilityError("Please Enter Your Any Disability.")
            isFlage = false
        }
        else {
            setAnydisabilityError("")
        }

        return isFlage;
    }

    const disableRightClick = (e) => {
    e.preventDefault();
  };

    return (
        <>
            <div className='fullview' onContextMenu={disableRightClick}>
                <TopBar />

                <div className='container mt-4'>
                    <div className='row mt-5 align-items-center gx-0'>
                        <div className="col-lg-5 col-12 p-4 d-flex justify-content-center align-items-center mt-3">
                            <img className='image h-100 w-100' src={logo} alt='logo' />
                        </div>
                        <div className="col-lg-6 col-12  card p-3">

                            <p className="h5 text-center mt-2 pt-2">Personal Details</p>

                            {/* <p> <label htmlFor=" Maritalstatus" className=" Maritalstatus" >Martial status </label> */}
                            <select id=" Maritalstatus" className="form-control mt-2" value={Maritalstatus} onChange={(e) => setMaritalstatus(e.target.value)}>
                                <option value="">--Please Enter your Marital Status  --</option>
                                <option value="1">Never Married</option>
                                <option value="2">Widower</option>                               
                                <option value="3">Divorced</option>
                                <option value="4">Awaiting Divorce</option>
                                 <option value="5">Widow</option>
                            </select><span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }}>{MaritalstatusError}</span>
                            {/* </p> */}


                            {/* <p> <label htmlFor="Height" className="Height" >Height </label> */}
                            <select id="Height" className="form-control mt-2" value={Height} onChange={(e) => setHeight(e.target.value)}>
                                <option value="">-- Please Enter your Height --</option>
                                <option value="137">137 CM </option>
                                <option value="138">138 CM</option>
                                <option value="139">139 CM</option>
                                <option value="140">140 CM</option>
                                <option value="141">141 CM</option>
                                <option value="142">142 CM</option>
                                <option value="143">143 CM</option>
                                <option value="144">144 CM</option>
                                <option value="145">145 CM</option>
                                <option value="146">146 CM</option>
                                <option value="147">147 CM</option>
                                <option value="148">148 CM</option>
                                <option value="149">149 CM</option>
                                <option value="150">150 CM</option>
                                <option value="151">151 CM</option>
                                <option value="152">152 CM</option>
                                <option value="153">153 CM</option>
                                <option value="154">154 CM</option>
                                <option value="155">155 CM</option>
                                <option value="156">156 CM</option>
                                <option value="157">157 CM</option>
                                <option value="158">158 CM</option>
                                <option value="159">159 CM</option>
                                <option value="160">160 CM</option>
                                <option value="161">161 CM</option>
                                <option value="162">162 CM</option>
                                <option value="163">163 CM</option>
                                <option value="164">164 CM</option>
                                <option value="165">165 CM</option>
                                <option value="166">166 CM</option>
                                <option value="167">167 CM</option>
                                <option value="168">168 CM</option>
                                <option value="169">169 CM</option>
                                <option value="170">170 CM</option>
                                <option value="171">171 CM</option>
                                <option value="172">172 CM</option>
                                <option value="173">173 CM</option>
                                <option value="174">174 CM</option>
                                <option value="175">175 CM</option>
                                <option value="176">176 CM</option>
                                <option value="177">177 CM</option>
                                <option value="178">178 CM</option>
                                <option value="179">179 CM</option>
                                <option value="180">180 CM</option>
                                <option value="181">181 CM</option>
                                <option value="182">182 CM</option>
                                <option value="183">183 CM</option>
                                <option value="184">184 CM</option>
                                <option value="188">188 CM</option>
                                <option value="189">189 CM</option>
                                <option value="190">190 CM</option>
                                <option value="191">191 CM</option>
                                <option value="192">192 CM</option>
                                <option value="193">193 CM</option>
                                <option value="194">194 CM</option>
                                <option value="195">195 CM</option>
                                <option value="196">196 CM</option>
                                <option value="197">197 CM</option>
                                <option value="198">198 CM</option>
                                <option value="199">199 CM</option>
                                <option value="200">200 CM</option>
                                <option value="201">201 CM</option>
                                <option value="202">202 CM</option>
                                <option value="203">203 CM</option>
                                <option value="204">204 CM</option>
                                <option value="205">205 CM</option>
                                <option value="206">206 CM</option>
                                <option value="207">207 CM</option>
                                <option value="208">208 CM</option>
                                <option value="209">209 CM</option>
                                <option value="210">210 CM</option>
                                <option value="211">211 CM</option>
                                <option value="212">212 CM</option>
                                <option value="213">213 CM</option>
                                <option value="214">214 CM</option>
                                <option value="215">215 CM</option>
                                <option value="216">216 CM</option>

                            </select><span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }}>{HeightError}</span>
                            {/* </p> */}

                            {/* <p> <label htmlFor="Familystatus" className="Familystatus">Family status </label> */}
                            <select id="Familystatus" className="form-control mt-2" value={Familystatus} onChange={(e) => setFamilystatus(e.target.value)}>
                                <option value="">--Please Enter your Family status--</option>
                                <option value="1">Middle Class</option>
                                <option value="2">Upper-Middle Class</option>
                                <option value="3">High Class</option>
                                <option value="4">Rich/Affluent</option>
                            </select><span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }}>{FamilystatusError}</span>
                            {/* </p> */}



                            {/* <p> <label htmlFor="Familytype" className="Familytype">Family type </label> */}
                            <select id="Familytype" className="form-control mt-2" value={Familytype} onChange={(e) => setFamilytype(e.target.value)}>
                                <option value="">-- Please Enter your Family type--</option>
                                <option value="1">Joint</option>
                                <option value="2">Nuclear</option>
                            </select><span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }}>{FamilytypeError}</span>
                            {/* </p> */}


                            {/* <p> <label htmlFor="familyvalues" className="familyvalues">Family values </label> */}
                            <select id="familyvalues" className="form-control mt-2" value={familyvalues} onChange={(e) => setfamilyvalues(e.target.value)}>
                                <option value="">--Please Enter your Family values--</option>
                                <option value="1">Orthodox</option>
                                <option value="2">Traditional</option>
                                <option value="3">Moderate</option>
                                <option value="4">Liberal</option>


                            </select><span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }}>{familyvaluesError}</span>
                            {/* </p> */}


                            {/* <p> <label htmlFor="Anydisability" className="Anydisability">Any disability </label> */}
                            <select id="Anydisability" className="form-control mt-2" value={Anydisability} onChange={(e) => setAnydisability(e.target.value)}>
                                <option value="">--Please select a Disability--</option>
                                <option value="1">Normal</option>
                                <option value="2">Physically Challenged</option>
                            </select><span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }}>{AnydisabilityError}</span>
                            {/* </p> */}


                            <button onClick={clicktoQualificationscreen} type="button" className="btn w-100 mt-3 text-light"  style={{backgroundColor:"var(--primary-color)",fontWeight:"bold"}}>Next page</button>


                        </div>
                    </div>
                    <Offeradd/>
                </div>

            </div>
            <footer className='bg-dark text-white text-center '>
                <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
            </footer>
        </>

    );
}

export default Personal;